import { Alert, Badge, Group, Text } from "@mantine/core";
import { IconPlayerPause } from "@tabler/icons-react";
import type { SuppressedDeliveryMethod } from "../../services/workflows.service";

const MAX_CARD_WIDTH = 650;

interface SuppressedDeliveryMethodsAlertProps {
  methods: SuppressedDeliveryMethod[];
}

/**
 * Explains why deliveries for certain methods never leave the queue.
 *
 * Without this the queue looks broken: rows sit at "Pending" indefinitely with
 * no error and no sent time. Naming the paused methods turns that into an
 * understood, deliberate state.
 */
export function SuppressedDeliveryMethodsAlert({
  methods,
}: SuppressedDeliveryMethodsAlertProps) {
  if (methods.length === 0) return null;

  return (
    <Alert
      color="orange"
      variant="light"
      p="xs"
      maw={MAX_CARD_WIDTH}
      role="status"
    >
      <Group gap="xs" wrap="wrap">
        <IconPlayerPause size={14} />
        <Text size="sm" fw={600}>
          Delivery paused for some methods
        </Text>
        {methods.map((method) => (
          <Badge key={method.key} color="orange" variant="filled" size="sm">
            {method.label}
          </Badge>
        ))}
      </Group>
      <Text size="xs" mt={4}>
        Highlighted rows stay at Pending and are not sent. They go out as soon
        as the method is released.
      </Text>
    </Alert>
  );
}
